import { render, staticRenderFns } from "./DadosBancarios.vue?vue&type=template&id=b32db85c&scoped=true&"
import script from "./DadosBancarios.vue?vue&type=script&lang=js&"
export * from "./DadosBancarios.vue?vue&type=script&lang=js&"
import style0 from "./DadosBancarios.vue?vue&type=style&index=0&id=b32db85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32db85c",
  null
  
)

export default component.exports